import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSketchPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3327_36787)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.24768 9.73052C6.24781 8.6858 6.66381 7.68391 7.40421 6.94513C9.06384 5.28966 12.0795 2.28156 13.5252 0.837806C13.7423 0.621496 14.0366 0.5 14.3435 0.5C14.6503 0.5 14.9446 0.621496 15.1617 0.837806C15.3786 1.05415 15.5 1.34781 15.5 1.65385C15.5001 1.95978 15.3784 2.25322 15.1617 2.46965C13.716 3.91337 10.7004 6.92147 9.04073 8.57697C8.30052 9.31571 7.29437 9.73052 6.24768 9.73052ZM6.24768 9.73052C1.04324 5.11514 -3.00482 12.0385 5.09096 12.0385C10.2954 12.0385 10.2954 15.5 7.98231 15.5",
			stroke: "#DFCBF5",
			strokeOpacity: .7,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3327_36787",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgSketchPen;
